export const SUBMIT_MODEL_ROUTE = '/submit-model';

export interface SubmitModelNavOptions {
  datasetKey?: string | null;
  label?: string | null;
}

export function submitModelQueryParams(
  options: SubmitModelNavOptions = {},
): Record<string, string> {
  const query: Record<string, string> = {};
  const datasetKey = options.datasetKey?.trim();
  const label = options.label?.trim();
  if (datasetKey) {
    query['dataset'] = datasetKey;
  }
  if (label) {
    query['label'] = label;
  }
  return query;
}
